import React from 'react'
import useDispatch from 'hooks/use-dispatch'
import loadByIdDeepProductVariantAction from 'modules/product-variant/redux/actions/load-by-id-deep'
import logEventAnalyticsUtil from 'utils/analytics/log-event'

const ANALYTICS_EVENT = {
  SHOW_FULL_SIZE_CONVERSION_CARD: 'SHOW_FULL_SIZE_CONVERSION_CARD'
}

const ProductCollectionItemLoadFullSizeConversion = ({
  shouldShowFullSizeConversion,
  variantId
}) => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (shouldShowFullSizeConversion) {
      logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_FULL_SIZE_CONVERSION_CARD)
      dispatch(loadByIdDeepProductVariantAction(variantId))
    }
  }, [
    shouldShowFullSizeConversion,
    variantId
  ])

  return null
}

export default ProductCollectionItemLoadFullSizeConversion
